import {
  DELETE_ROUTES_CATALOG,
  DELETE_ROUTES_CATALOG_SUCCESS,
  DELETE_ROUTES_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const deleteRoutesCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case DELETE_ROUTES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case DELETE_ROUTES_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case DELETE_ROUTES_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
